import Popup from '../../components/base/Popup';

/**
 * Открытие фотографии из отзыва
 */
export default () => {
    const $popup = $('.popup--review-pic-full');
    const popupInstance = new Popup($popup);
    const $img = $popup.find('.js-popup-photo-img');
    const $popupInner = $popup.find('.js-popup-photo');
    popupInstance.init();

    $img.on('load', () => {
        $popupInner.removeClass('is-loading');
    });

    $(document).on('click', '.js-review-pic-link', e => {
        e.preventDefault();

        const $target = $(e.currentTarget);
        const imgLink = $target.attr('href');

        $popupInner.addClass('is-loading');
        $img.attr('src', imgLink);

        popupInstance.open();
    });
};
